import { computed, ref, watch, type Ref } from 'vue'

export const globalZIndex = ref(50)

export const dialogsOpen = ref(0)

/** A composable to help determine the z-index value of dialogs when multiple are shown at the same time. */
export function useDialogZIndex(isOpen?: Ref<boolean>) {
  const localZIndex = ref(50)

  if (isOpen) {
    watch(
      () => isOpen.value,
      (val) => {
        if (val) {
          globalZIndex.value += 1
          localZIndex.value = globalZIndex.value + dialogsOpen.value
          dialogsOpen.value += 1
        } else {
          globalZIndex.value -= 1
          localZIndex.value = 50
          dialogsOpen.value -= 1
        }
      }
    )
  }

  const showOverlay = computed(() => dialogsOpen.value <= 1)

  return {
    zIndex: localZIndex,
    globalZIndex,
    showOverlay
  }
}
